<template>
  <PhotoGallery :photos="book.photos" v-if="book"/>
</template>

<script>
  import PhotoGallery from '../components/PhotoGallery';
  export default {
    name: 'BookPage',
    components: {
      PhotoGallery
    },
    data() {
      return {
        book: false//gbl.books[this.$route.params.book]
      }
    },
    mounted() {
      if(gbl.books[this.$route.params.book]) {
        this.book = gbl.books[this.$route.params.book];
      } else {
        this.$router.push({ path: `/page-not-found` });
      }
    }
  }
</script>


// WEBPACK FOOTER //
// resources/js/pages/BookPage.vue